import React from 'react';
import PropTypes from 'prop-types';
import { trackEvent } from 'dibs-tracking';
import { SAVE_ITEM_PDP_FLOW } from 'dibs-buyer-layout/src/authModal/authentication/authFlowConstants';
import {AutoModal} from 'dibs-buyer-layout/src/entries/index';
import userHelper from '../../../global/core/commonjs/userHelper';
import { setForceFavoriteItem } from '../../actions/PdpActions.es';
import copy from './MultiplePdpVisitsModalCopy.json';
import { SAME_PDP } from './multiplePdpVisitsModalConstants.es';

const getTrackingLabel = modalType =>
    modalType === SAME_PDP ? 'same pdp view limit reached' : 'pageview limit reached on pdp';

const trackItemFavorited = modalType => {
    trackEvent({
        category: 'item favoriting',
        action: 'item added',
        label: getTrackingLabel(modalType),
    });
};

const authModalShow = ({ modalType, context }) => {
    userHelper
        .checkLogin(
            {
                label: getTrackingLabel(modalType),
            },
            SAVE_ITEM_PDP_FLOW,
            false
        )
        .then(() => {
            context.executeAction(setForceFavoriteItem);
            trackItemFavorited(modalType);
        });
};

const MultiplePdpVisitsModal = ({ modalType, item, context }) => (
    <AutoModal
        copy={copy[modalType]}
        item={item}
        onCtaClick={() => {
            authModalShow({ modalType, context });
        }}
        tracking={{
            category: 'promo interaction',
            action:
                modalType === SAME_PDP
                    ? 'same pdp view limit modal'
                    : 'pageview limit reached on pdp modal',
            label: getTrackingLabel(modalType),
        }}
    />
);

MultiplePdpVisitsModal.propTypes = {
    modalType: PropTypes.string.isRequired,
    item: PropTypes.object,
    context: PropTypes.object,
};

export default MultiplePdpVisitsModal;



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/MultiplePdpVisitsModal/MultiplePdpVisitsModal.jsx